/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import { supplierFile } from '../../../constant/userType';
import ButtonAction from "../../../components/buttons/ButtonAction";
import HeadTittle from "../../../components/HeadTittle";
import routes from "../../../Routes/routes";
import DivContainerBody from "../../../components/DivContainerBody";
import {EditIcon} from "../../../components/buttons/IconButtons";
import {CustomTextField} from "../../../components/CustomTextField";
import ContractorRestrictionApp from "./Functionality/ContractorRestrictionApp";
import {permissionObj} from "../../../Helpers/permission";

const RestrictionUsers = (props) => {
    const { userType } = props;
    const {
        t,
        DEV,
        permission,
        navigate,
        emptyFields,
        waitTime,
        setWaitTime,
        handleUpdateRestriction,
    } = ContractorRestrictionApp(props);

    if(userType === supplierFile){
        if(!DEV && (!permission?.includes(permissionObj.WEB_SUPPLIER_READ) || !permission?.includes(permissionObj.WEB_SUPPLIER_RESTRICTION_UPDATE))) navigate(routes.forbidden);
    }else{
        if(!DEV && (!permission?.includes(permissionObj.WEB_CONTRACTOR_READ) || !permission?.includes(permissionObj.WEB_CONTRACTOR_RESTRICTION_UPDATE))) navigate(routes.forbidden);
    }

    return (
        <>
            <HeadTittle name={`${userType}-restriction`} link={
                userType === supplierFile
                    ? routes.suppliers.list
                    : routes.contractor.list
            }>
                <ButtonAction
                    id='btn_ru_update'
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={() => {
                        handleUpdateRestriction();
                    }}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className={"row mt-5"}>
                    <div className={"col-sm-12 col-md-6 col-xxl-6 col-lg-6"}>
                        <CustomTextField id={"txt_ru_time_to_be_deleted"}
                                         trans={"time_to_be_deleted"}
                                         type={"number"}
                                         onChange={(e) => setWaitTime(e.target.value)}
                                         value={waitTime}
                                         disabled={false}
                                         required={true}
                                         emptyFields={emptyFields}
                                         suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{t('days')}</p>}

                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default RestrictionUsers;
